<template>
	<div>
		<el-date-picker
			format="yyyy-MM-dd"
			value-format="yyyy-MM-dd"
			v-model="dataValue"
			type="date"
			placeholder="选择日期"
			size="small"
			:picker-options="expireTimeOption"
			@change="dataFun"
			style="margin-bottom: 20px;margin-right: 20px;">
		</el-date-picker>
		<el-time-select
			v-model="timeValue"
			:picker-options="{
				start: '00:00',
				step: '00:60',
				end: '23:00'
			}"
			size="small"
			placeholder="选择时间"
			@change="timeFun">
		</el-time-select>
	</div>
</template>

<script>
export default {
	name: 'timeDataSelector',
	props: {
		expireTimeOption: {
			type: Object
		}
	},
	data () {
		return {
			dataValue: '',
			timeValue: '',
		}
	},
	methods: {
		dataFun() {
			this.$emit('dataFun', this.dataValue)
		},
		timeFun() {
			this.$emit('timeFun', this.timeValue + ':00' )
		}
	},
}
</script>
